export default {
  data() {
    return {
      allPrecisionData: [],
    };
  },
  mounted() {
    this.getAllPrecision();
  },
  methods: {
    getAllPrecision() {
      this.$axios.post("/TradePage/allPrecision", {}).then((res) => {
        if (res.data.code === "000000") {
          this.allPrecisionData = res.data.data;
        }
      });
    },
    getSymbolPrecision(symbol, type) {
      symbol = symbol && symbol.endsWith("USD") ? symbol + "T" : symbol;
      let symbolWithBase =
        symbol && symbol.includes("/") ? symbol : `${symbol}/USDT`;
      let precisionData = this.allPrecisionData.find(
        (item) => item.symbol === symbolWithBase,
      );
      if (precisionData) {
        if (type === "price") {
          return precisionData.baseCoinScale;
        } else if (type === "coin") {
          return precisionData.coinScale;
        }
      }
      return type === "price" ? 4 : 8;
    },
  },
};
